export default __webpack_public_path__ + "static/builder-ca62b52a6ce727099e78cc9d742c17a8.png";